/// <reference path="../typings/Common.d.ts" />

export enum ActionType {
    IDENT_SELECTION,

    GET_COMMUNICATION_DATA,
    GET_CONFIGURATION_DATA,

    CREATE_FOLDERS,
    SAVE_CONFIGURATION,
    DELETE_CONFIGURATION,

    REST_CREATE_FOLDERS,
    REST_SAVE_CONFIGURATION,
    REST_DELETE_CONFIGURATION,
    
    TOGGLE_RESPONSES,
    TOGGLE_RESPONSES_DATA,

    DOWNLOAD_CONFIGURATION_FILES,
    UPLOAD_CONFIGURATION_FILES,
    REST_UPLOAD_CONFIGURATION_FILES,
    
    MODAL_CLOSE,
    YESNO_MODAL_CLOSE,

    TIMEOUT,
    WEBAPI_ERROR
}

export module ActionData {
    export class Base {
        toString(): string {
            return JSON.stringify(this);
        }
    }

    export class IdentitySelectionData extends Base {
        merchantId: string;
        terminalId: string;

        constructor(merchantId: string, terminalId: string) {
            super();
            this.merchantId = merchantId;
            this.terminalId = terminalId;
        }
    }
    
    export class ToggleResponseData extends IdentitySelectionData {
        value: boolean;
        
        constructor(merchantId: string, terminalId: string, value: boolean) {
            super(merchantId, terminalId);
            this.value = value;
        }
    }
    
    export class ConfigurationData extends IdentitySelectionData {
        configuration: IConfigurationData;
        
        constructor(merchantId: string, terminalId: string, configuration: IConfigurationData) {
            super(merchantId, terminalId);
            this.configuration = configuration;
        }
    }

    export class ConfigurationFilesDownload extends IdentitySelectionData {
        constructor(merchantId: string, terminalId: string) {
            super(merchantId, terminalId);
        }
    }

    export class ConfigurationFilesUpload extends IdentitySelectionData {
        file: any;

        constructor(merchantId: string, terminalId: string, file: any) {
            super(merchantId, terminalId);

            this.file = file;
        }
    }
    
    export class WebApiResponse extends Base {
        data: any;
        params: any;
        
        constructor(data: Base, params: any) {
            super();
            this.data = data;
            this.params = params;
        }
    }

}


// WEBPACK FOOTER //
// ./Scripts/actions/ActionTypes.ts